import { Form } from "@/types/form.types"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { fetchForms, addForm, updateForm, addFormWithFile, updateFormWithFile, deleteForm } from "./formsThunks"

interface FormsState{
  forms: Form[]
  loadingForms: boolean
  errorForms: string | null
}
const initialState: FormsState = {
  forms: [],
  loadingForms:false,
  errorForms:null
}

const formsSlice = createSlice({
  name : 'forms'
  ,initialState,
  reducers:{},
  extraReducers: (builder) =>{
    builder
    .addCase(fetchForms.pending, (state)=>{
      state.loadingForms = true
      state.errorForms= null
    })
    .addCase(fetchForms.fulfilled, (state, action: PayloadAction<Form[]>) => {
            state.loadingForms = false
            state.forms = action.payload
            state.errorForms = null
          })
    .addCase(fetchForms.rejected, (state, action: any) => {
            state.loadingForms = false
              state.errorForms = action.payload || action.error?.message || 'Failed to load documents'
      
    })
    .addCase(addForm.pending, (state) => {
      state.errorForms = null
    })
    .addCase(addForm.fulfilled, (state, action: PayloadAction<Form>) => {
      state.forms.push(action.payload)
    })
    .addCase(addForm.rejected, (state, action: any) => {
      state.errorForms = action.payload || action.error?.message || 'Failed to add form'
    })
    .addCase(updateForm.pending, (state) => {
      state.errorForms = null
    })
    .addCase(updateForm.fulfilled, (state, action: PayloadAction<any>) => {
      const index = state.forms.findIndex(f => f.id === action.payload.id)
      if (index > -1) {
        state.forms[index] = { ...state.forms[index], ...action.payload }
      }
    })
    .addCase(updateForm.rejected, (state, action: any) => {
      state.errorForms = action.payload || action.error?.message || 'Failed to update form'
    })
    // Add Form with File handlers
    .addCase(addFormWithFile.pending, (state) => {
      state.errorForms = null
    })
    .addCase(addFormWithFile.fulfilled, (state, action: PayloadAction<Form>) => {
      state.forms.push(action.payload)
    })
    .addCase(addFormWithFile.rejected, (state, action: any) => {
      state.errorForms = action.payload || action.error?.message || 'Failed to add form with file'
    })
    // Update Form with File handlers
    .addCase(updateFormWithFile.pending, (state) => {
      state.errorForms = null
    })
    .addCase(updateFormWithFile.fulfilled, (state, action: PayloadAction<Form>) => {
      const index = state.forms.findIndex(f => f.id === action.payload.id)
      if (index > -1) {
        state.forms[index] = { ...state.forms[index], ...action.payload }
      }
    })
    .addCase(updateFormWithFile.rejected, (state, action: any) => {
      state.errorForms = action.payload || action.error?.message || 'Failed to update form with file'
    })
    // Delete Form handlers
    .addCase(deleteForm.pending, (state) => {
      state.errorForms = null
    })
    .addCase(deleteForm.fulfilled, (state, action: PayloadAction<string>) => {
      state.forms = state.forms.filter(f => f.id !== action.payload)
    })
    .addCase(deleteForm.rejected, (state, action: any) => {
      state.errorForms = action.payload || action.error?.message || 'Failed to delete form'
    })
},
})

export default formsSlice.reducer